export const name = 'speculationRules' as const

export const SpeculationRulesSymbol = Symbol('SpeculationRulesSymbol')
